import { service } from '@/request/server'

// 菜单列表
export const menuList = (params) => (
  service({
    url: '/Menus/menuList',
    method: 'GET',
    params
  })
)

// 菜单详情
export const menuDetail = (params) => (
  service({
    url: '/Menus/menuDetail',
    method: 'GET',
    params
  })
)

// 添加/编辑菜单
export const saveMenu = (params) => (
  service({
    url: '/Menus/saveMenu',
    method: 'POST',
    data: params
  })
)


// 拒绝/通过菜单
export const setMenuStatus = (params) => (
  service({
    url: '/Menus/setMenuStatus',
    method: 'POST',
    data: params
  })
)

// 删除菜单
export const delMenu = (params) => (
  service({
    url: '/Menus/delMenu',
    method: 'GET',
    params
  })
)

// 轮播图列表
export const carouselList = (params) => (
  service({
    url: '/Carousel/carouselList',
    method: 'GET',
    params
  })
)

// 添加/编辑轮播图
export const saveCarousel = (params) => (
  service({
    url: '/Carousel/saveCarousel',
    method: 'POST',
    data: params
  })
)


// 删除轮播图
export const delCarousel = (params) => (
  service({
    url: '/Carousel/delCarousel',
    method: 'GET',
    params
  })
)
